// Essential Free Gifts v90/v91 already observes successful Ajax cart mutations.
// Its exported cart context also starts idle timers. Keep mutation hooks and
// subscribers intact; remove only those timers for this inspected app version.
// Resolve the app's actual deployed extension URL; do not import an older copy.
const entry = [...document.scripts].find(script => /\/essential-free-gifts-(90|91)\/assets\/app-embed-/.test(script.src));
if (entry) {
try {
const { C: GiftCartContext } = await import(new URL('./cart-context-5UT0S91n.js', entry.src).href);
const marker = Symbol.for('print-finland.gift-cart-events');
if (!GiftCartContext.prototype[marker]) {
  const originalInit = GiftCartContext.prototype.init;
  const originalDestroy = GiftCartContext.prototype.destroy;
  const recovery = new WeakMap();
  GiftCartContext.prototype.init = function (...args) {
    originalInit.apply(this, args);
    // Fail open if the app changes: never disable its synchronization hooks.
    if (!('_startupPollTimer' in this) || !('_steadyPollTimer' in this) || typeof this.syncNow !== 'function' || typeof this._scheduleSync !== 'function') return;
    for (const key of ['_startupPollTimer', '_steadyPollTimer']) {
      if (this[key] !== null) clearInterval(this[key]);
      this[key] = null;
    }
    if (recovery.has(this)) return;
    let hiddenAt = 0;
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') hiddenAt = Date.now();
      else if (hiddenAt && Date.now() - hiddenAt > 30000) {
        hiddenAt = 0;
        this._scheduleSync(this._originalFetch || fetch);
      }
    };
    const onPageShow = event => { if (event.persisted) this._scheduleSync(this._originalFetch || fetch); };
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pageshow', onPageShow);
    recovery.set(this, () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pageshow', onPageShow);
    });
  };
  GiftCartContext.prototype.destroy = function (...args) {
    recovery.get(this)?.();
    recovery.delete(this);
    return originalDestroy.apply(this, args);
  };
  Object.defineProperty(GiftCartContext.prototype, marker, { value: true });
}
} catch (error) { console.warn('[Print Finland] Gift app compatibility check: original app behavior retained.', error); }
}
